import apiUrl from '../../../utils/settings';

export const getSearchProductsUrl = () => {
  return apiUrl + `/v2/search/`;
};
